export default __webpack_public_path__ + "static/media/night1.2b7643ef.jpeg";